export module Text {
  export const NoServerData = 'An error occurred while retrieving data from the server!'
}